export default __webpack_public_path__ + "static/media/bkg--location-lifestyle-1.a8f42c83.jpg";